// extracted by mini-css-extract-plugin
module.exports = {"countdown__container":"Countdown_countdown__container__4jRRS","hidden":"Countdown_hidden__ariKa"};